import React, { Component } from "react";
import { Modal, Accordion, Card } from "react-bootstrap";
import NavigateNextSharpIcon from "@material-ui/icons/NavigateNextSharp";
import releaseItems from "./demo-version-history.json";
import "../rightside-modal/rightside-modal.css";
import "./version-history.css";

export default class VersionHistoryModal extends Component {
	state = {
		activeKey: "0",
	};

	handleClose = () => {
		if (typeof this.props.handleModal === "function") {
			this.props.handleModal(false);
		}
	};

	handleAccordionSelect = (eventKey) => {
		this.setState((prev) => ({
			activeKey: prev.activeKey === eventKey ? null : eventKey,
		}));
	};

	render() {
		const sortedReleaseItems = [...(Array.isArray(releaseItems) ? releaseItems : [])].sort(
			(a, b) => new Date(b.releaseDate || 0).getTime() - new Date(a.releaseDate || 0).getTime()
		);

		return (
			<Modal
				className="info-filter right mainfooterModal right-modal-wrap version-history-modal"
				show={!!this.props.show}
				onHide={this.handleClose}
				autoFocus
				keyboard
			>
				<Modal.Header closeButton>
					<div>
						<h5>Version History</h5>
						<p>View the history of changes and improvements</p>
					</div>
				</Modal.Header>
				<Modal.Body>
					<Accordion activeKey={this.state.activeKey} onSelect={this.handleAccordionSelect}>
						{sortedReleaseItems.map((entry, index) => (
							<Card key={`${entry.version}-${entry.releaseDate}`} className="version-history-card">
								<Accordion.Toggle as={Card.Header} eventKey={String(index)} className="version-history-toggle mb-1">
									<div className="version-history-heading">
										<div className="version-history-title-wrap">
											<h6>{entry.version}</h6>
											<span>{entry.releaseDate}</span>
										</div>
										<NavigateNextSharpIcon
											className={`version-history-arrow ${this.state.activeKey === String(index) ? "open" : ""}`}
										/>
									</div>
								</Accordion.Toggle>
								<Accordion.Collapse eventKey={String(index)}>
									<Card.Body className="p-0">
										{/* <p className="version-history-summary">{entry.summary}</p> */}
										<ul className="version-history-list">
											{Array.isArray(entry.items) &&
												entry.items.map((point, pointIndex) => (
													<li key={`${entry.version}-item-${pointIndex}`}>{point}</li>
												))}
										</ul>
									</Card.Body>
								</Accordion.Collapse>
							</Card>
						))}
					</Accordion>
				</Modal.Body>
			</Modal>
		);
	}
}
